import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";


function ModalUpdateSpc(props) {

  const [br, setBR] = useState(false);
  const [controlSnack, setControlSnack] = useState(false);

  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (controlSnack) showNotification("br")
  }, [controlSnack]);

  async function handleAprovedSpc(e) {
    e.preventDefault();
    const response = await api.put('/spc/' + props.props.id);
    if (response.status === 200) {
      props.onHide();
      props.loadSpc();
    }

  }


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Deletar contato
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleAprovedSpc}>
        <Modal.Body>
          <h4> Aprovar esse cliente?</h4>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit" >
              APROVAR
            </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Cliente deletado com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalUpdateSpc;